import styled from "styled-components";

export const PopupContainer = styled.div`
    width: inherit;
    outline: 0;
    background-color: white;
    padding: 1em;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`

export const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 700;
  max-width: 70%;
  max-height: 70%;
  width: fit-content;
  outline: 0;
  overflow: auto;
  color: black;
`;

export const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 500;
`;

export const StyledModal = styled.div`
  z-index: 100;
  background: white;
  position: relative;
  margin: auto;
  border-radius: 8px;
`;

export const Header = styled.div`
  font-weight: bold;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

export const HeaderText = styled.div`
  align-self: center;
`;

export const CloseButton = styled.button`
  font-size: 0.8rem;
  border: none;
  border-radius: 3px;
  margin-left: 0.5rem;
  :hover {
    cursor: pointer;
  }
  background-color: inherit;
  color: inherit;
`;

export const Content = styled.div`
  padding: 10px;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const ScenarioTab = styled.div`
  padding: .5em;
  background-color: #f2f2f2;
  cursor: pointer;
  border-left: .1rem solid;
  :hover {
    background-color: darkgrey;
  }
`;